



























































import { Component, Vue, Prop } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import OperadoraHospitalStore from '@/components/RemuneracaoMedica/financeiro/Store/OperadoraHospitalStore'
import EventBus from '@/plugins/EventBus'
import { validateCNPJ } from '@/utils/common'

@Component
export default class ModalCriarEditarOperadoraHospital extends Vue {
  @Prop({ default: 'CREATE' }) mode!: string

  formValido: boolean = true
  salvando: boolean = false

  get store() {
    return getModule(OperadoraHospitalStore, this.$store)
  }

  get show() {
    return this.store.modalCriarEditar
  }

  set show(value: boolean) {
    this.store.setModalCriarEditar(value)
  }

  validarCnpj(v: string) {
    return validateCNPJ((v || '').replace(/\D/g, '')) || 'CNPJ inválido'
  }

  async salvar() {
    const form = this.$refs.form as any
    if (form && !form.validate()) return

    this.salvando = true
    const response: any = await this.store.salvar()
    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Registro salvo com sucesso!', icon: 'done', color: '#2E7D32' })
      this.show = false
      this.$emit('update-items-table')
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Erro ao salvar.', icon: 'warning', color: '#C62828' })
    }
    this.salvando = false
  }
}
